import { Flex } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import Logo from "./Logo";

const Menu = () => {
    return (
        <Flex as="header" bg={'surface.card'} w={'100%'} justifyContent={'center'} alignItems={'center'}
              h={{ base: '64px', md: '72px' }} borderBottom="1px solid" borderColor="surface.border"
              position="sticky" top="0" zIndex="999">
            <Flex w="100%" maxW="7xl" px={{ base: '16px', md: '24px', '2xl': 0 }} alignItems={'center'}>
                <RouterLink to="/" aria-label="Evenado">
                    <Logo />
                </RouterLink>
            </Flex>
        </Flex>
    )
}

export default Menu;
